import axios from "axios";
import { silentRequest } from "../authConfig";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * @function DeletePDF delete pdf
 * @param {Object} payload {instance, account, id: id of document}
 */
export const DeletePDF = (payload) => {
  return payload.instance
    .acquireTokenSilent({ ...silentRequest, account: payload.account })
    .then((tokenResponse) => {
        return axios
        .delete(API_URL + "/documents/" + payload.id, {
          headers: {
            Authorization: "Bearer " + tokenResponse.accessToken,
          },
        }).then((res) => {
          return res.status;
        }).catch((error) => {
          return error;
        })
    })
    .catch((error) => {
      payload.instance.acquireTokenRedirect(silentRequest);
      return error;
    });
};
